<p class="result-count col-gray-500 mt-2 text-small">
  <span class="bold">{{count || 0}}</span>
  <ng-content></ng-content> found
</p>
